import { Theme } from "../../types";
import { ACTION_SET_THEME } from "./constants";

export interface IThemeState {
  value: Theme;
}

export interface IThemeAction {
  type: string;
  theme?: Theme;
}

const INITIAL_STATE: IThemeState = { value: "light" };

const themeReducer = (state = INITIAL_STATE, action: IThemeAction): IThemeState => {
  if (action.type === ACTION_SET_THEME && action.theme !== undefined) {
    return { value: action.theme };
  }
  return state;
};

export default themeReducer;
